var VehicleCheckHealthCtrl = function ($scope, $q, $timeout, previousState, customerModelService, vehicleService, apiService, $log, 
    SettingsConstants, $state, bootstrapParameters, loaderService, errorRouterService, VALIDATION, ssWidgetService) {
    //for stat
    var approximateOdometerValue;
    //get appointments
    //loader
    $scope.checkHealthLoader = loaderService.getOrCreate("checkHealthLoader");
    //existing appointmens
    $scope.appointments = customerModelService.getExistingAppointments();
    // initial values
    $scope.lastService = '';
    $scope.lastOdometerReading = '';
    // retrieve current vehicle from the model service
    $scope.currentVehicle = customerModelService.getCurrentVehicle();
    // reset current maintenance interval
    $scope.currentVehicle.setCurrentMaintenanceInterval();
    // strange validation issue if odometer value does not set explicitly
    // valisation on require does not work
    $scope.currentVehicle.odometer = $scope.currentVehicle.odometer || null;
    // retrieve current customer from the model service
    $scope.currentCustomer = customerModelService.getCustomer();
    // get the information about the maintenance histore regarding to current vehicle
    $scope.odometerValueKind = $scope.currentVehicle.getManufacturer().kilometersOrMiles;
    // check vehicle updates settings.
    $scope.isRecallsEnabled = window.appSettings.enableRecalls;
    // Check showVehicleAlerts setting
    $scope.showVehicleAlerts = window.appSettings.ossShowVehicleAlerts;
    // Check enableProtectionPlans setting
    $scope.enableProtectionPlans = window.appSettings.enableProtectionPlans;
    // Check telematicsMileageEnabled setting
    $scope.telematicsMileageEnabled = window.appSettings.telematicsMileageEnabled;
    
    $scope.currentThemeName = window.appSettings.currentThemeName;

    $scope.goToSummary = function (apptPreview) {
        if (apptPreview.status === 'shown') {
            ssWidgetService.disable();
        }

        loaderService.pendingNotify(true);

        apptPreview.getAppointment.requestTransformation = ({ url, methodData, data }) => {

            let searchKey = $scope.currentCustomer.foundType;
            let searchValue;
            if (searchKey === 'byVin') {
                searchValue = $scope.currentVehicle.vin;
            }
            else if (searchKey === 'byPhone') {
                searchValue = $scope.currentCustomer.phone;
            }
            else if (searchKey === 'byEmail') {
                searchValue = $scope.currentCustomer.email;
            }
            else if (searchKey === 'byRefNumber') {
                let s = url.split('/');
                let appointmentID = s[s.length - 1];
                for (const element of $scope.appointments) {
                    for (const link of element.links) {
                        if (link.href.indexOf(appointmentID) !== -1) {
                            searchValue = element.confirmationCode;
                            break;
                        }
                    }
                }
            }

            url += "/customerSearchAttribute/" + searchKey + "/customerSearchValue/" + searchValue;
            return { url, methodData, data };
        };

        $scope.checkHealthLoader.addPromise(
            apptPreview.getAppointment()
                .then(function (appointment) {
                    var services = appointment.services;

                    ssWidgetService.setSessionId('urn.dfx.confirmation-code.' + appointment.confirmationCode);

                    // resolveCustomerConcernsServices, resolveDealerRecommendedServices, resolveFactoryRequiredServices
                    return appointment.resolveCustomerConcernsServices().then(function (data) {

                        function processServices(appServices, ossServices) {
                            _.forEach(appServices, function (s) {
                                s.selected = true;
                            });
                            var services = _.concat(appServices, ossServices);
                            var sortedServices = _.orderBy(services, { selected: true }, 'desc');
                            return _.uniqBy(sortedServices, 'id');
                        }

                        var repairServices = processServices(appointment.services.repair, data);
                        var drServices = processServices(appointment.services.drs, []);
                        var frServices = processServices(appointment.services.frs, []);
                        processServices(appointment.services.recalls, []);
                        processServices(appointment.services.alerts, []);

                        customerModelService.setCurrentAppointment(appointment);
                        customerModelService.setCustomerConcernsServices(repairServices);
                        customerModelService.setConcernsDescription(appointment.customerConcernsInfo);
                        customerModelService.setDealerRecommendedServices(drServices, true);
                        customerModelService.setFactoryRequiredServices(frServices, true);
                        customerModelService.setCurrentTransportationOption(appointment.transportationOption);
                        customerModelService.setCurrentScheduledTime({ time: appointment.scheduledTime, available: true });

                        var vehicle = customerModelService.getCurrentVehicle();
                        vehicle.odometer = appointment.mileage.value;

                        return $q.all([
                            appointment.getAdviser(),
                            (appointment.resolveTransportationOption || appointment.transportationOption.resolveTransportationOption)(),
                            customerModelService.resolveSurveyServices(repairServices)
                        ]);

                    });


                })
                .then(function (arr) {
                    customerModelService.setCurrentAdviser(arr[0]);
                    customerModelService.setCurrentTransportationOption(arr[1]);

                    $timeout(function () {
                        $state.go('summary');
                    })

                })
                .catch(function (err) {
                    $log.error('Something went wrong due to appointment acquiring');
                })
        );
    };
    // check if this state has to be skipped, instantly got to 'summary' state.
    // Bug #14216
    if ($state.params.skip && $scope.appointments.length) {
        $scope.goToSummary($scope.appointments[0]);
    } else if ($state.params.skip && !$scope.appointments.length) {
        // $state.go('searchresults');
    }

    // go to vehicle summary page
    $scope.gotoBookAppointment = function () {
        if ($scope.odometerForm.$valid) {
            var currentAppointment = customerModelService.getCurrentAppointment();
            //reset saved appointment data.
            if (currentAppointment) {
                resetAppointmentData();
            }
            $state.go('bookappointment');
        } else {
            $scope.odometerForm.$setDirty();
        }
    };

    $scope.toggleUpdatesPopup = function () {
        $scope.showUpdatesPopup = !$scope.showUpdatesPopup;
    };

    //Separate the function to get both recalls and alerts
    $scope.checkRecallsAlertsUpdates = function () {
        if ($scope.isRecallsEnabled || $scope.showVehicleAlerts) {
            $scope.recallsPending = true;

            customerModelService.resolveRecallsUpdates().then(function (data) {
                $scope.recalls = customerModelService.getRecallsUpdates();
                if (_.size(data)) {
                    $scope.showUpdatesMsg = true;
                }
            })
                .catch(function (err) {
                    $scope.recalls = null;
                })
                .finally(function () {
                    if ($scope.showVehicleAlerts) {
                        checkAlertsUpdates();
                    } else {
                        $scope.recallsPending = false;
                        $scope.alertsPending = false;
                    }
                });
        }
    };

    //This one just gets recalls
    $scope.checkRecalls = function () {
        if ($scope.isRecallsEnabled) {
            $scope.recallsPending = true;

            customerModelService.resolveRecallsUpdates().then(function (data) {
                $scope.recalls = customerModelService.getRecallsUpdates();
                if (_.size(data)) {
                    $scope.showUpdatesMsg = true;
                }
            })
                .catch(function (err) {
                    $scope.recalls = null;
                })
                .finally(function () {
                    if ($scope.telematicsMileageEnabled || $scope.showVehicleAlerts) {
                        $scope.alertsPending = true;
                        $scope.recallsPending = true;
                    } else {
                        $scope.recallsPending = false;
                    }
                });
        }
    };

    function checkAlertsUpdates() {
        if ($scope.telematicsMileageEnabled || $scope.showVehicleAlerts) {
            $scope.alertsPending = true;

            customerModelService.resolveAlertsUpdates().then(function (data) {
                $scope.alerts = data;
                if (_.size(data) > 0) {
                    $scope.showUpdatesMsg = true;
                }
            })
                .catch(function (err) {
                    $scope.alerts = null;
                })
                .finally(function () {
                    $scope.recallsPending = false;
                    $scope.alertsPending = false;
                });
        }
        else {
            $scope.alerts = [];
            $scope.alertsPending = false;
            $scope.recallsPending = false;
        }
    }

    function checkProtectionPlanUpdates() {
        if (customerModelService.areProtectionPlansLoaded()) {
            let proPlans =  customerModelService.getProtectionPlansUpdates();
            if(proPlans)
            {
                $scope.protectionPlans  = proPlans;
            }
             else {
                $scope.protectionPlans  = [];
                $scope.protectionPlanPending = false;
             }
         }
         else{
             $scope.protectionPlanPending = true;
             customerModelService.resolveProtectionPlansUpdates().then(function (data) {
                 if (_.size(data) > 0) {
                    $scope.protectionPlans = data.ProtectionPlans;
                    customerModelService.setProtectionPlansUpdates($scope.protectionPlans);  
                     $scope.showUpdatesMsg = true;
                 }
                 else     $scope.protectionPlans = [];
             })
                 .catch(function (err) {
                     $scope.protectionPlans = [];
                     $scope.protectionPlanPending = false;
                 })
                 .finally(function () {
                     $scope.protectionPlanPending = false;
                 });
               
         }
       
     }

    function resetAppointmentData() {
        customerModelService.setCurrentAppointment();
        customerModelService.setCustomerConcernsServices();
        customerModelService.setConcernsDescription();
        customerModelService.setDealerRecommendedServices();
        customerModelService.setFactoryRequiredServices();
        customerModelService.setCurrentTransportationOption();
        customerModelService.setCurrentScheduledTime();
        customerModelService.setCurrentAdviser();
    }

    function init() {
        if ($scope.isRecallsEnabled && !$state.params.skip) {
            $scope.recalls = customerModelService.getRecallsUpdates();
            // Temporary solution:
            // To prevent confirmed appointment with time segment blocked by
            // recall opcode checkRecallsUpdates will be called every time on
            // Check Health initialization.
            // task-19121-recall-to-existing-appointment

            // if (!$scope.recalls) {
            $scope.checkRecalls();
            // }
            /*
            else {
                //preselect existing recalls by default.
                customerModelService.setRecallsUpdates($scope.recalls);
            }
            */
        }

        if ($scope.enableProtectionPlans) {
            checkProtectionPlanUpdates();
        }

        if ($scope.telematicsMileageEnabled || $scope.showVehicleAlerts) {
            // Get odometer reading and alerts from Telematics
            apiService.getCatalog()
            .then(function (catalog) {
                catalog.getVehicleTelematics($scope.currentVehicle.vin).then(function (telematicsData) {
                    if (telematicsData) {
                        $scope.currentVehicle.setTelematicsData(telematicsData);
                        $scope.currentVehicle.odometer = $scope.currentVehicle.getTelematicsOdometer();
                        //39739: TMNA SmartPath - Vehicle Alert Admin Setting for OS - Disabled setting still shows vehicle alert count
                        if ($scope.showVehicleAlerts && !$state.params.skip) {
                            checkAlertsUpdates();
                        }
                    } 
                    $scope.alertsPending = false;
                    $scope.recallsPending = false;
                });
            });
        }

        var maintenance = $scope.currentVehicle.getMaintenance();
        if (maintenance) {
            // last service visited
            $scope.lastService = maintenance.lastService;
            // last odometer value
            $scope.lastOdometerReading = maintenance.lastOdometerReading;

            var mileageParam = bootstrapParameters.getParameter('mileage');
            if (mileageParam) {
                $scope.currentVehicle.odometer = parseInt(mileageParam);
                if ($scope.currentVehicle.odometer >= $scope.lastOdometerReading) {
                    $state.go('bookappointment');
                    return;
                } else {
                    $timeout(function () {
                        $scope.$broadcast('setFocusOnError');
                        $scope.odometerForm.$setDirty();
                    }, 0);
                }
            }

            if (!$scope.currentVehicle.odometer) {
                // days between Last Service Visit Date and Enrollment Date
                var diffDaysA = moment(maintenance.lastService).diff(maintenance.enrollmentDate, 'days');
                // difference between Last Service Visit Mileage and Enrollment Mileage
                var diffMileage = maintenance.lastOdometerReading - maintenance.enrollmentMileage;
                // Average Mileage = (Last Service Visit Mileage – Enrollment Mileage)  /  (# of Days between Last Service Visit Date and Enrollment Date)
                var averageMileage = diffMileage / diffDaysA;
                // days between Current Date and Last Service Visit Date
                var diffDaysB = moment().diff(maintenance.lastService, 'days');
                // Approximate Odometer Value = Last Service Visit Mileage + (# of Days between Last Service Visit Date and Current Date) * Average Mileage
                approximateOdometerValue = Math.round(maintenance.lastOdometerReading + diffDaysB * averageMileage);

                //for "require validator" number input should report null when blank
                // $scope.currentVehicle.odometer = approximateOdometerValue || null;

                $timeout(function () {
                    $scope.odometerForm.odometerField.$setViewValue(approximateOdometerValue || null);
                }, 0);
            }
        }
    }

    init();

    $scope.$watch('currentVehicle.odometer', function (newValue, oldValue) {

        value = parseInt(newValue);

        if (!_.isNaN(value) && $scope.lastOdometerReading) {
            $scope.odometerForm.odometerField.$setValidity('odometerLess', value >= $scope.lastOdometerReading);
        } else {
            $scope.odometerForm.odometerField.$setValidity('odometerLess', true);
        }
    });

};
VehicleCheckHealthCtrl.$inject = ['$scope', '$q', '$timeout', 'previousState', 'customerModelService', 'VehicleService', 'apiService', '$log', 'SettingsConstants', '$state', 'bootstrapParameters', 'LoaderService', 'errorRouterService', 'VALIDATION', 'ssWidgetService'];

module.exports = VehicleCheckHealthCtrl;

